import React, { Component } from 'react';
import UserForm from './forms/UserForm';

import './ClientView.css';
//import { ClinicPatientList } from '../../components/DataSelectList';
import { FormLabeledItem } from '../../components/FormUI';
import BiopedModal from '../../components/BioPedModal'
import UserDetails from './UserDetails';
import ClinicPatientList from '../../components/datalists/ClinicPatientList';

export default class ClientView extends Component{
    state = {};

    setView(v){     

        this.setState({view:v});
    }

    componentDidMount(){
        //console.log('Calendar View did Mount!!!!!!!!!!!')
        if(this.props.onSectionHeader){
            this.props.onSectionHeader(<h2 className='client-view-section-header'>Manage Clients</h2>)
        }
    }

    render(){
        let view;
        switch(this.state.view){
            case 'details':
                view = <UserDetails user={this.state.client} onBack={() => this.setState({view: 'search', client:null})} onEdit={(user)=> this.setState({client:user, view:'search'})} />;
            break;
            default:
                view = <div><div className='client-search'>
                            <FormLabeledItem label='Search Existing Clients' parentItem>
                                <ClinicPatientList 
                                    onOptionSelect={(d) => {
                                        this.setState({client:d, view:'details'})
                                    } } 
                                />
                            </FormLabeledItem>
                            
                        </div>
                        <div className='content-section'>
                            <UserForm user={this.state.client} />
                        </div></div>               
            break;
        }

        return(
            <div className='client-view'>
                {view}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Clients/ClientView.js